import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import './style.css'
import { SERVER_IP, PORT } from '../../Server'
import axios from 'axios';

class Projects extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            templist: [],
            count: 1
        }
    }


    componentDidMount() {
        this.getAlldata();
    }
    playTimmer = () => {
 
        if (this.state.templist.length == this.state.count) {
            this.setState({ count: 1, list: this.state.templist[this.state.count - 1] })
        } else {
            this.setState({ count: this.state.count + 1, list: this.state.templist[this.state.count - 1] })
        }

    }

    getAlldata = () => {
        var _this = this;
        axios.post(`${SERVER_IP}/projects`, {})
            .then(function (response) {

                var data = response.data.data;

                var chunksize = 5;


                var chunks = [];

                data.forEach((item) => {
                    if (!chunks.length || chunks[chunks.length - 1].length == chunksize)
                        chunks.push([]);

                    chunks[chunks.length - 1].push(item);
                });

                _this.setState({ templist: chunks }, () => _this.playTimmer())
                setInterval(() => _this.playTimmer(), 10000)

            })
            .catch(function (error) {
                // swal("Something Went Wrong,Please Retry")
            });
    }

    render() {
      
        return (
            <>
                <div class="project_container">
                    <div class="wrapper" style={{ width: "90%", height: "90%" }}>
                        <div class="d-flex aling-items-center justify-content-between mb-3">
                            <h3>Running Projects</h3>

                            <svg width="150px" x="0px" y="0px"
                                viewBox="0 0 512 165.3">
                                <g>
                                    <path class="st0" d="M81.7,2c0.2,0.1,0.5,0.3,0.7,0.3c7.9,0.3,15.5,2,22.8,4.7c4.2,1.5,8.3,3.3,12.3,5.3c6.1,3,11.9,6.7,17.3,10.8
		c2.7,2.1,5.4,4.2,8.1,6.3c0.5,0.4,0.9,0.5,1.5,0c2.4-1.8,4.9-3.5,7.3-5.3c2-1.5,3.9-3,5.9-4.6c0.1-0.1,0.3-0.2,0.5-0.3
		c-0.3,2-0.5,3.8-0.8,5.7c-0.3,2.5-0.7,4.9-1,7.4c-0.3,2.3-0.6,4.6-1,7c-0.3,2.4-0.7,4.9-1,7.3c-0.4,2.6-0.7,5.2-1.1,7.8
		c0,0.2-0.4,0.5-0.6,0.4c-4.5-0.6-9-1.2-13.5-1.9c-3.4-0.5-6.7-0.8-10.1-1.3c-2.9-0.4-5.7-0.8-8.6-1.2c-0.9-0.1-1.8-0.2-2.7-0.3
		c0-0.1,0-0.2,0-0.2c0.8-0.7,1.7-1.4,2.5-2.1c2.9-2.4,5.9-4.7,8.8-7.1c0.2-0.1,0.2-0.6,0.1-0.8c-1.7-3.1-4-5.6-6.7-7.8
		c-3.1-2.6-6.5-4.6-10.2-6.3c-4.8-2.2-9.8-3.8-15-4.9c-2.7-0.5-5.4-0.9-8.1-1.3c-4-0.6-8-0.6-12.1-0.5c-6,0.2-12,0.9-17.7,2.8
		c-3.3,1.1-6.5,2.4-9.5,3.8c-4,1.9-7.5,4.7-10.5,8c-0.6,0.7-1.2,1.4-1.8,2.2c-2.5-2-5-3.9-7.6-6c0,8.9,0,17.5,0,26.2
		c9.3,0,18.6,0,28.1,0c-2.6-2.9-5.1-5.7-7.7-8.5c0.7-0.6,1.4-1.2,2.1-1.6c2.9-1.8,5.8-3.7,8.8-5.3c4-2.1,8.3-3.4,12.8-4
		c2.6-0.3,5.2-0.3,7.8-0.6c1.2-0.1,2,0.3,2.8,1.2c7.5,7.5,15,15,22.5,22.5c17,17,34,33.9,51.1,50.9c0.7,0.7,0.8,1.1,0.4,2
		c-2.7,6.8-6.3,13-10.6,18.8c-1.7,2.2-3.5,4.2-5.4,6.3c-4.6,5.3-10.1,9.6-15.9,13.4c-8.5,5.5-17.7,9.4-27.5,11.7
		c-3.5,0.8-7,1.3-10.6,1.8c-4.1,0.6-8.2,0.7-12.2,0.5c-6.3-0.3-12.5-1.2-18.6-2.9c-5-1.4-9.9-3.3-14.5-5.7c-4.4-2.3-8.6-5-12.4-8.2
		c-2.4-2.1-4.8-4.3-7.1-6.6c-1.1-1-2-2.2-3-3.4c-0.7-0.8-0.9-0.9-1.7-0.3c-4,2.7-7.9,5.4-11.9,8.1c-0.4,0.2-0.7,0.4-1.3,0.8
		c0.1-0.9,0.1-1.6,0.2-2.3c0.3-2.9,0.6-5.7,0.9-8.6c0.3-3.1,0.4-6.2,0.7-9.3c0.4-4.6,0.9-9.1,1.4-13.6c0.1-0.6,0.4-0.8,1-0.7
		c2.8,0.4,5.6,0.8,8.4,1.2c2.4,0.3,4.8,0.6,7.2,0.9c2.5,0.3,5,0.7,7.5,1c2.5,0.3,4.9,0.6,7.4,0.9c1.3,0.2,2.7,0.4,4.2,0.6
		c-1.2,1-2.3,2-3.3,2.9c-2.3,1.9-4.7,3.8-7,5.8c-1.3,1.1-1.3,1.2-0.3,2.6c2.4,3.5,5.4,6.4,8.9,8.9c6.5,4.7,13.8,7.6,21.6,9.4
		c3,0.7,6.2,1.1,9.3,1.5c2.9,0.3,5.7,0.5,8.6,0.5c3.9,0,7.7-0.3,11.6-1c4.7-0.8,9.3-2,13.8-3.8c4.8-1.9,9.3-4.5,13.3-7.8
		c1.2-1,2.4-2.1,3.6-3.2c0.8-0.8,0.9-0.8,1.7,0c1.1,1,2.1,2,3.2,3c0.9,0.8,1.8,1.6,2.8,2.4c0.1,0,0.2-0.1,0.3-0.1
		c-0.2-8.9-0.3-17.8-0.5-26.7c-9.1,0-18.1,0-27.2,0c0,0.1-0.1,0.2-0.1,0.3c0.2,0.2,0.4,0.5,0.7,0.7c2.2,2.1,4.4,4.1,6.5,6.2
		c0.8,0.7,0.8,0.9,0,1.6c-1.7,1.8-3.8,3-5.9,4.1c-4.8,2.6-9.7,4.7-14.9,6.3c-2.9,0.9-5.9,1.7-9,1.7c-1.7,0-3.1-0.5-4.4-1.8
		c-9.2-9.3-18.5-18.6-27.8-27.8c-15-14.9-30-29.9-45-44.8c-1.1-1.1-1.3-2.3-1-3.7c0.9-3.9,2.8-7.4,4.8-10.8
		c2.6-4.2,5.6-8.1,8.8-11.9c3.9-4.5,8.3-8.6,13-12.3c4.9-3.9,10.2-7.2,15.8-9.9c6-2.9,12.3-5.1,18.9-6.1c3-0.5,6.1-0.7,9.2-1.1
		c0.2,0,0.5-0.2,0.7-0.3C77.7,2,79.7,2,81.7,2z M48.2,77.5c-0.1,0-0.2,0.1-0.2,0.1c0.4,0.7,0.7,1.6,1.3,2.2c3.1,3.3,6.3,6.5,9.5,9.7
		c4.5,4.6,9,9.1,13.5,13.7c3.2,3.3,6.5,6.5,9.7,9.8c1.4,1.4,2.8,2.9,4.2,4.3c1.2,1.2,3.1,1.2,4.2,0.1c1.2-1.1,1.1-3-0.1-4.2
		c-0.9-1-1.9-2-2.8-2.9c-4.2-4.3-8.4-8.6-12.7-12.9c-3.7-3.7-7.4-7.4-11.1-11.1c-3.6-3.6-7.2-7.3-10.8-10.9c-0.9-0.9-2-0.9-3.1-0.5
		C48.8,75.3,48.2,76.3,48.2,77.5z M102,105.2c1.3-0.2,2.3-0.8,2.7-1.8c0.5-1.3,0.2-2.5-0.7-3.5c-2.8-2.8-5.5-5.6-8.3-8.5
		c-6.4-6.4-12.7-12.9-19.1-19.3c-1.6-1.6-3.3-3.3-4.9-4.9c-1.4-1.4-2.7-2.9-4.1-4.2c-1.2-1.2-3.1-1.2-4.2-0.1
		c-1.1,1.1-1.1,3,0.1,4.2c2,2,3.9,4.1,5.9,6.1c3.1,3.2,6.2,6.4,9.4,9.5c7.1,7.1,14.1,14.3,21.2,21.4
		C100.5,104.6,101.3,104.8,102,105.2z M80.4,49.2c-1.6,0.1-2.5,0.5-3,1.6c-0.5,1.2-0.3,2.5,0.6,3.4c3.4,3.5,6.8,6.9,10.2,10.4
		c2.8,2.8,5.5,5.6,8.3,8.5c5.8,5.9,11.6,11.7,17.4,17.6c1.2,1.2,3.1,1.3,4.2,0.1c1.1-1.1,1.1-3-0.1-4.2c-3.3-3.4-6.7-6.8-10-10.2
		c-2.3-2.4-4.7-4.8-7-7.1c-6.3-6.4-12.6-12.8-18.9-19.1C81.6,49.7,80.7,49.4,80.4,49.2z"/>
                                    <path class="st0" d="M228.3,55.2c-1.9,0-3.8,0-5.7,0c-0.7,0-0.9-0.3-0.9-0.9c0-2.4,0-4.9,0-7.3c0-0.7,0.2-0.9,0.9-0.9
		c3.8,0,7.7,0,11.5,0c0.7,0,0.9,0.2,0.9,0.9c0,2.5,0,4.9,0,7.4c0,0.6-0.2,0.9-0.9,0.9C232.1,55.1,230.2,55.2,228.3,55.2z"/>
                                    <path class="st1" d="M450.5,165.3c-0.6-0.2-1.2-0.4-1.9-0.5c-6-1-9.5-4.2-10.9-10.2c-0.4-1.6-0.5-3.4-0.6-5.1c0-25.3,0-50.5,0-75.8
		c0-2-0.2-3.9-1.2-5.7c-0.8-1.4-2-2-3.5-2c-1,0-2,0.2-3,0.4c-0.7,0.1-1,0.5-0.9,1.2c0,2.9,0,5.8,0,8.7c0,16.6,0,33.2,0,49.9
		c0,1.3,0,1.3-1.3,1.3c-3.7,0-7.4,0-11.2,0c-0.9,0-1.1-0.3-1.1-1.1c0-19.9,0-39.7,0-59.6c0-0.7,0.2-1.1,0.8-1.4
		c3.9-1.8,8-3.3,12.3-3.7c2.3-0.2,4.6-0.4,6.9-0.3c2.8,0.1,5.5,0.5,8.1,1.6c3.9,1.6,6,4.7,6.8,8.7c0.4,2,0.5,4.1,0.5,6.1
		c0,25.1,0,50.1,0,75.2c0,1.2,0.2,2.5,0.4,3.7c0.4,1.9,2.3,3.2,4.6,3.3c0.8,0,1.6-0.1,2.4-0.1c0.5,0,0.8,0.1,0.8,0.6
		c0,1.3,0,2.5,0,3.8c0,0.6-0.3,0.8-0.8,0.7c-0.8,0-1.7,0-2.5,0c-0.3,0-0.6,0.2-0.8,0.3C453.3,165.3,451.9,165.3,450.5,165.3z"/>
                                    <path class="st0" d="M180.5,97.6c1.6,0,3.2-0.1,4.8-0.1c2.6,0,5.2,0,7.8,0c0.9,0,1.2,0.2,1.2,1.1c0,6.2,0,12.4,0,18.6
		c0,1.5,0.3,2.9,1.1,4.2c1.3,2.2,5.5,2.2,6.4-0.3c0.4-1,0.8-2.1,0.8-3.2c0.1-6.3,0.1-12.6,0.2-18.8c0-1.8-0.7-3.2-1.9-4.5
		c-2.1-2.2-4.8-3.6-7.2-5.4c-3-2.2-6.1-4.2-8.9-6.6c-1.9-1.6-3.3-3.9-3.4-6.5c-0.2-5.6-0.2-11.3-0.2-16.9c0-2.3,0.5-4.6,1.5-6.7
		c1.5-3,3.9-4.6,7-5.5c2.2-0.6,4.4-0.8,6.7-0.9c3.2-0.1,6.4,0.1,9.5,0.9c4.6,1.2,7.4,4.3,8.3,8.9c0.4,2,0.5,4,0.5,6
		c0.1,3.6,0,7.3,0,10.9c0,0.8-0.2,1-1,1c-3.6,0-7.3,0-10.9,0c-0.9,0-1-0.3-1-1.1c0-5.2,0-10.4,0-15.6c0-1.1-0.2-2.2-0.5-3.2
		c-0.7-2.5-3.6-3.7-5.9-2.6c-0.4,0.2-0.7,0.8-0.8,1.2c-0.3,1.3-0.6,2.6-0.6,3.9c-0.1,5.1-0.2,10.1-0.2,15.2c0,0.8,0.2,1.7,0.3,2.5
		c0.3,1.8,1.4,3.2,2.8,4.2c3.8,2.8,7.6,5.5,11.5,8.2c3.1,2.2,5.5,4.9,6.8,8.6c0.5,1.4,0.8,3,0.9,4.5c0.2,3.5,0.3,7.1,0.2,10.6
		c-0.1,2.8-0.5,5.7-1,8.4c-0.9,4.9-4.2,7.6-8.9,8.8c-3.3,0.8-6.7,1-10.2,0.9c-2.8-0.2-5.6-0.6-8.3-1.7c-3.3-1.4-5.4-3.8-6.4-7.3
		c-0.4-1.5-0.5-3-0.8-4.5c0-0.2-0.2-0.4-0.3-0.6C180.5,108.8,180.5,103.2,180.5,97.6z"/>
                                    <path class="st0" d="M512,108.6c-0.1,0.3-0.3,0.7-0.3,1c0,3.3-0.4,6.6-1.1,9.8c-1,4.3-3.8,6.8-7.9,8c-3.6,1.1-7.2,1.2-10.9,1
		c-2.6-0.1-5.3-0.5-7.8-1.4c-3.5-1.4-5.6-4-6.4-7.5c-0.4-1.9-0.7-3.9-0.7-5.9c-0.1-3.3,0-6.6,0-9.9c0-0.8,0.2-1,1-1
		c3.6,0,7.3,0,10.9,0c0.7,0,1,0.2,1,1c0,3.6,0,7.2,0.2,10.9c0.1,2,0.3,4.1,0.6,6.1c0.2,1.5,1.5,2.3,2.9,2.4c2.8,0.2,4-1.3,4.6-3.8
		c0.1-0.7,0.2-1.5,0.2-2.2c0-4.4,0-8.9,0-13.3c0-1.4-0.5-2.4-1.4-3.4c-2.3-2.5-5.1-4.5-7.9-6.5c-2.4-1.6-4.9-3.3-7.2-5
		c-2.7-2.1-4.5-4.7-4.8-8.2c-0.3-3.7-0.4-7.4,0.8-11c1.2-3.7,3.8-5.8,7.4-6.9c2.2-0.7,4.5-0.8,6.9-0.9c3-0.1,6,0.1,8.9,0.8
		c2.1,0.5,4,1.3,5.6,2.9c1.7,1.7,2.5,3.9,2.9,6.2c0.4,2.7,0.5,5.5,0.8,8.2c0.1,0.6-0.2,0.9-0.8,0.9c-3.6,0-7.2,0-10.8,0
		c-0.6,0-0.9-0.2-0.9-0.8c0-2.1,0-4.2-0.2-6.3c-0.1-1.9-0.4-3.7-1.5-5.4c-1.5-2.2-4.7-1.6-5.8,0.5c-0.3,0.6-0.6,1.4-0.6,2.1
		c-0.1,2.7-0.2,5.4,0,8c0.1,2.1,1.2,3.8,3,5c3.5,2.3,7,4.6,10.4,7.1c3.2,2.3,5.9,4.9,7.5,8.6c0.6,1.4,0.8,3,1.2,4.6
		c0.1,0.2,0.2,0.5,0.3,0.7C512,106.1,512,107.3,512,108.6z"/>
                                    <path class="st0" d="M242.4,97.1c0-9.9,0-19.8,0-29.7c0-0.8,0.2-1.3,1-1.6c3.8-1.8,7.8-3.2,12-3.8c4.5-0.7,9-0.7,13.3,0.9
		c1.5,0.5,2.7,0.5,4.2,0.1c3.2-0.8,6.4-1.6,9.6-1.5c3.3,0.1,6.7,0.5,9.8,1.9c3.5,1.7,5.4,4.5,6.1,8.1c0.4,1.9,0.5,4,0.6,5.9
		c0,16.3,0,32.5,0,48.8c0,1.7,0.1,1.5-1.5,1.5c-3.3,0-6.6,0-9.8,0c-1.1,0-1.2,0-1.2-1.2c0-17.8,0-35.7,0-53.5c0-1.8-0.3-3.6-1.2-5.2
		c-1.1-1.7-2.7-1.9-4.5-1.8c-0.6,0.1-1.1,0.3-1.7,0.3c-0.9,0.1-1.1,0.5-1.1,1.4c0,19.5,0,39,0,58.5c0,1.4,0,1.4-1.5,1.4
		c-3.5,0-7.1,0-10.6,0c-1.2,0-1.2,0-1.2-1.2c0-17.9,0-35.7,0-53.6c0-1.5-0.4-3-0.9-4.3c-0.8-2-2.7-2.9-4.9-2.5
		c-0.8,0.1-1.6,0.3-2.4,0.5c-0.3,0.1-0.5,0.5-0.6,0.8c-0.1,0.2,0,0.5,0,0.8c0,19.4,0,38.7,0,58.1c0,1.4,0,1.4-1.4,1.4
		c-3.6,0-7.1,0-10.7,0c-0.9,0-1.1-0.3-1.1-1.1C242.4,116.9,242.4,107,242.4,97.1z"/>
                                    <path class="st0" d="M340.3,92.9c0,9.9,0,19.9,0,29.8c0,1-0.3,1.5-1.2,1.9c-4,1.7-8,3.2-12.3,3.7c-4.8,0.6-9.7,0.5-14.3-1.3
		c-4-1.5-6.2-4.5-7-8.6c-0.4-2-0.5-4.1-0.6-6.2c0-16.5,0-32.9,0-49.4c0-1.3,0-1.3,1.3-1.3c3.6,0,7.1,0,10.7,0c1.4,0,1.4,0,1.4,1.4
		c0,16.6,0,33.3,0,49.9c0,2.5-0.1,5.1,0.6,7.6c0.6,2.1,1.6,3.6,4.4,3.4c1-0.1,2-0.2,3-0.3c0.5-0.1,0.7-0.3,0.7-0.8
		c0-0.3,0-0.6,0-0.9c0-19.6,0-39.3,0-58.9c0-1.4,0-1.4,1.4-1.4c3.5,0,7.1,0,10.6,0c1.2,0,1.2,0,1.2,1.2
		C340.3,72.8,340.3,82.9,340.3,92.9z"/>
                                    <path class="st0" d="M394.9,79.8c0-2.1,0.1-4.2,0-6.3c0-1.2-0.2-2.4-0.5-3.6c-0.7-2.8-2.1-3.7-4.7-3.8c-1.9,0-3.9,0.1-5.8,0.3
		c-0.5,0-0.7-0.1-0.7-0.6c0-1.1,0-2.2,0-3.3c0-0.2,0.3-0.4,0.5-0.6c0,0,0.1,0,0.2,0c3.2-0.1,6.4-0.2,9.6-0.2c1.8,0,3.6,0.4,5.4,0.7
		c2.2,0.5,4.2,1.5,5.8,3.1c1.8,1.8,2.8,4.1,3.2,6.5c0.3,2,0.5,4,0.5,6c0,16.1,0,32.3,0,48.4c0,1.4,0,1.4-1.4,1.4
		c-5.9,0-11.9,0.1-17.8,0c-3.4-0.1-6.8-0.8-9.7-2.7c-3.1-2-5.1-4.8-5.9-8.4c-0.5-2.4-0.8-4.9-0.9-7.3c-0.1-4.7-0.1-9.4,0-14.1
		c0-2.4,0.3-4.8,1.2-7.2c1.4-3.6,3.9-5.9,7.5-7.2c2.3-0.9,4.8-1.3,7.3-1.2C390.7,79.8,392.8,79.8,394.9,79.8z M395,85.2
		c-1.7,0-3.4-0.2-5-0.1c-1,0-1.8,0.6-2.3,1.4c-1.1,1.6-1.3,3.4-1.4,5.2c0,7-0.1,13.9,0,20.9c0,2.3,0.5,4.6,0.9,6.9
		c0.2,1.5,1.6,2.5,3.1,2.5c1.3,0,2.7,0,4,0c0.2,0,0.4-0.1,0.7-0.1C395,109.7,395,97.6,395,85.2z"/>
                                    <path class="st0" d="M346.5,80.5c0-11.1,0-22.2,0-33.3c0-1.3,0.1-1.3,1.4-1.1c1.7,0.2,3.4,0.3,5.2,0.5c2.1,0.2,4.2,0.3,6.3,0.6
		c0.2,0,0.5,0.4,0.5,0.6c0.1,0.3,0,0.6,0,1c0,21.7,0,43.3,0,65c0,2.2,0.3,4.5,0.7,6.7c0.3,1.7,2.1,2.8,3.8,2.9c1,0,2,0,3,0
		c0.6,0,0.8,0.2,0.8,0.8c0,1.2,0,2.4,0,3.5c0,0.6-0.2,0.8-0.8,0.8c-2.2,0-4.4,0.2-6.5,0.1c-4-0.2-7.7-1.2-10.7-4.1
		c-2-2-3-4.4-3.4-7.1c-0.3-1.9-0.4-3.9-0.4-5.8C346.5,101.1,346.5,90.8,346.5,80.5z"/>
                                    <path class="st0" d="M234.9,94.8c0,10.6,0,21.2,0,31.9c0,1.3,0,1.3-1.3,1.3c-3.6,0-7.3,0-10.9,0c-0.9,0-1.1-0.3-1.1-1.1
		c0-21.4,0-42.8,0-64.2c0-0.9,0.3-1.1,1.2-1.1c3.7,0,7.3,0,11,0c0.9,0,1.1,0.3,1.1,1.2C234.9,73.4,234.9,84.1,234.9,94.8z"/>
                                    <path class="st0" d="M469.4,94.9c0,10.6,0,21.2,0,31.9c0,1.2,0,1.2-1.2,1.2c-3.7,0-7.3,0-11,0c-0.8,0-1.1-0.2-1.1-1
		c0-21.4,0-42.9,0-64.3c0-0.8,0.2-1,1-1c3.7,0,7.5,0,11.2,0c0.9,0,1,0.3,1,1.1C469.4,73.4,469.4,84.1,469.4,94.9z"/>
                                    <path class="st0" d="M462.7,55.2c-1.9,0-3.8,0-5.7,0c-0.6,0-0.9-0.2-0.9-0.9c0-2.5,0-5,0-7.5c0-0.6,0.2-0.8,0.8-0.8
		c3.9,0,7.7,0,11.6,0c0.6,0,0.8,0.2,0.8,0.8c0,2.5,0,5,0,7.5c0,0.7-0.3,0.9-0.9,0.9C466.6,55.1,464.6,55.2,462.7,55.2z"/>
                                </g>
                            </svg>

                        </div>
                        <table class="table  table-bordered table-striped table-hover" style={{ height: "81%" ,textAlign: "center",    fontSize: "16px"}}>
                            <thead class="table-dark">
                                <tr>
                                    <th scope="col">S.No</th>
                                    <th scope="col">Client</th>
                                    <th scope="col">Description </th>
                                    <th  scope="col">Start</th>
                                    <th scope="col">Status (Dept)</th>
                                    <th scope="col">Overall Completion</th>
                                    <th scope="col">Closure Date</th>
                                    <th scope="col">Remarks</th>

                                </tr>
                            </thead>
                            <tbody>
                                {this.state.list.map((list, index) =>
                                    <tr>

                                        <td>{list.sn}</td>
                                        <td>{list.client}</td>
                                        <td >{list.description}</td>
                                        <td>{list.startstatus_dept}</td>
                                        <td>{list.status}</td>
                                        <td>{list.overall_completion}</td>
                                        <td>{list.closure}</td>
                                        <td>{list.remarks}</td>
                                    </tr>


                                )}
                            </tbody>

                        </table>
                    </div>
                </div>
            </>
        )
    }
}
export default Projects

